import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  skeletonNavItem: {
    width: "100%",
    height: "1.75rem",
    marginBottom: "0.5rem",
    borderRadius: "0.25rem",
    padding: "10px 8px",
    backgroundColor: "hsl(200, 10%, 95%)",
  },
  skeleton: {
    marginTop: "2rem",
  },
}));

function NavItemSkeleton() {
  const classes = useStyles();

  return <div className={classes.skeletonNavItem}></div>;
}

function NavBarSkeleton() {
  const classes = useStyles();
  // arbitrary value, 6 looks pretty good though
  const numSkeletonItems = 6;
  return (
    <div className={classes.skeleton}>
      {[...Array(numSkeletonItems).keys()].map((idx) => (
        <NavItemSkeleton key={`NavItemSkeleton-${idx}`} />
      ))}
    </div>
  );
}

export default NavBarSkeleton;
